import React from 'react';

import { IS_WEB } from '../../lib/appConstants';
import { appendStyle } from '../../utils/appUtils';
// import { useFonts } from 'expo-font';

import Image from './Image';

// let Icon;
if (IS_WEB) {
  appendStyle(`@font-face {
  src: url(${(global as any).iconFont});
  font-family: icons;
}`);
} else {
  // Icon = createIconSet(iconsConfig, 'Icons', 'icons.ttf');
}

type Props = {
  style?: any;
  size: number;
  color?: string;
  title?: string;
  testID?: string;
  iconStyle?: any;
  source?: any;
  name?: string;
};

const IconWrapper = ({ style, source }: Props) => {
  // let [fontsLoaded] = !IS_WEB
  //   ? useFonts({
  //       Icons: require('../../assets/fonts/icons.ttf'),
  //     })
  //   : [true];
  // if (!fontsLoaded) return null;

  // return null;
  return source ? <Image style={style} resizeMode="contain" source={source} /> : null;
};

export default IconWrapper;
